import React, { useState, useEffect, useCallback } from 'react'
import { StripeProvider, Elements } from 'react-stripe-elements'
import { Helmet } from 'react-helmet-async'

import trackGMT from 'helpers/gtm'

const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
)

export const useStripePayload = ({ payload, stripe, onComplete }) => {
  const [error, setError] = useState(null)
  const run = useCallback(() => {
    if (stripe && payload && payload.payment_intent) {
      const { status, client_secret, payment_method } = payload.payment_intent
      async function check() {
        if (status === 'requires_action' && client_secret && payment_method) {
          const cardPayment = await stripe.confirmCardPayment(client_secret, {
            payment_method
          })
          console.log('confirmCardPayment payment_intent', cardPayment)
          if (cardPayment.error) {
            return setError(cardPayment.error.message)
          }
          onComplete(cardPayment.paymentIntent)
        }
        if (status === 'requires_action' && !payment_method) {
          trackGMT({
            event: 'custom',
            category: 'Stripe',
            action: 'Requires action missing payment method',
            label: JSON.stringify(payload)
          })
        }
        if (status === 'succeeded') {
          onComplete(payload.payment_intent)
        }
      }
      check()
    }
    if (stripe && payload && payload.setup_intent) {
      const { status, client_secret, payment_method } = payload.setup_intent
      async function check() {
        if (status === 'requires_action' && client_secret) {
          const cardPayment = await stripe.confirmCardSetup(client_secret, {
            payment_method
          })
          console.log('confirmCardSetup setup_intent', cardPayment)
          if (cardPayment.error) {
            return setError(cardPayment.error.message)
          }
          onComplete(cardPayment)
        }
        if (status === 'succeeded') {
          onComplete(payload.setup_intent)
        }
      }
      check()
    }
  }, [payload, stripe, onComplete, setError])
  useEffect(run, [run])
  return {
    error,
    run
  }
}

const StripeWrapper = ({ children }) => {
  const [stripe, setStripe] = useState(null)
  const loadStripe = !canUseDOM || (canUseDOM && !window.Stripe)
  const handleChangeClientState = (newState, addedTags) => {
    if (addedTags && addedTags.scriptTags) {
      if (!window.Stripe) {
        document.querySelector('#stripe-js').addEventListener('load', () => {
          setStripe(window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY))
        })
      }
    }
  }
  useEffect(() => {
    if (window.Stripe) {
      setStripe(window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY))
    }
  }, [setStripe])
  return (
    <>
      {loadStripe && (
        <Helmet onChangeClientState={handleChangeClientState}>
          <script
            id="stripe-js"
            src="https://js.stripe.com/v3/"
            type="text/javascript"
          />
        </Helmet>
      )}
      <StripeProvider stripe={stripe}>
        <Elements>{children}</Elements>
      </StripeProvider>
    </>
  )
}

export default StripeWrapper
